var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddDataSet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4439_45862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4404 4.2207H12.9404V3.7207V2.2207H13.2738V3.7207V4.2207H13.7738H15.2738V4.55404H13.7738H13.2738V5.05404V6.54737H12.9404V5.05404V4.55404H12.4404H10.9404V4.2207H12.4404Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.60645 12.554V12.2207H10.6064V12.554H7.60645Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1064 9.05396H7.10645V10.3873H11.1064V9.05396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4401 8.4407V14.3874H3.10677V5.05404H9.00677V3.7207H2.37344C2.0401 3.7207 1.77344 3.98737 1.77344 4.3207V15.1207C1.77344 15.3874 2.0401 15.7207 2.37344 15.7207H13.1734C13.4401 15.7207 13.7734 15.3874 13.7734 15.1207V8.4407H12.4401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1064 6.38745H7.10645V7.72078H11.1064V6.38745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.77376 9.05396H4.44043V10.3873H5.77376V9.05396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.77376 6.38745H4.44043V7.72078H5.77376V6.38745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.77376 11.7207H4.44043V13.054H5.77376V11.7207Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4439_45862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(1.77344 1.7207)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDataSet);
export default __webpack_public_path__ + "static/media/add-data-set.ae09b12ef386e30027b31b321fc48f67.svg";
export { ForwardRef as ReactComponent };